import { useContext, useLayoutEffect } from 'react';
import GoogleAnalyticsContext from '../contexts/GoogleAnalyticsContext';
import IdentityContext from '../contexts/IdentityContext';

export default function useGoogleAnalyticsRole() {
  const ga = useContext(GoogleAnalyticsContext);

  const { identity } = useContext(IdentityContext);

  // We want the dimension7 to be set before rendering.
  // In this way ga calls can be made during rendering with inclusion of the role.
  useLayoutEffect(() => {
    if (!ga) return;

    const dimension7 = identity.isAuthenticated ? identity.highestRole : 'anonymous';

    ga.set({ dimension7 });
  }, [identity, ga]);
}
